import React from 'react'
import { Product } from '../../../../modules/productsListing/types'
import { FormikProps, useFormikContext } from 'formik'
import { BoxV4 } from '@labrav/react-components'
import { Typography } from '@mui/material'
import { useStyles } from './PrivateOfferCustomMetaData.styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { CustomMetaDataV2 } from '../../../../common/components/CustomMetaDataV2/CustomMetaDataV2'

export type PrivateOfferCustomMetaDataProps = {
  product?: Product
}
export const PrivateOfferCustomMetaData: React.FC<
  PrivateOfferCustomMetaDataProps
> = ({ product }) => {
  const formikProps = useFormikContext() as FormikProps<Record<string, unknown>>
  const { classes } = useStyles()

  return (
    <div data-testid="Custom-metadata-section">
      <BoxV4
        heading={'Custom metadata'}
        headingIcon={
          <FontAwesomeIcon
            icon={faListCheck}
            style={{ width: '18px', height: '14px' }}
          />
        }
        isOptional={true}
      >
        <CustomMetaDataV2
          product={
            product
              ? ({
                  productId: product.productId,
                  productName: product.productName,
                } as React.ComponentProps<typeof CustomMetaDataV2>['product'])
              : undefined
          }
          subHeading={
            <Typography className={classes.sectionText}>
              Add a key-value pair to group or identify this offer for reporting
              purposes.
            </Typography>
          }
          formik={
            formikProps as unknown as FormikProps<Record<string, unknown>>
          }
          addButtonName={'Add more custom metadata'}
        />
      </BoxV4>
    </div>
  )
}
